import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupTwo from "../../components/header-signup-two/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import '../../App.css';
import {dataRegister} from "../../services/dataRegister";
import {cartRegister} from "../../services/cartRegister";
import {langRegister} from "../../services/langRegister";
import Slider, {Range} from 'rc-slider';
import 'rc-slider/assets/index.css';
import * as Icon from "react-feather";
import {marketRegister} from "../../services/marketRegister";
import Basket from "../../components/basket/component";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {tokenRegister} from "../../services/tokenRegister";
import {userRegister} from "../../services/userRegister";
import RegionSearch from "../../components/region-search/component";
import BoosterRegionSearch2 from "../../components/booster-region-search-2/component";
import ModalMaxRelated from "../../components/modal-maxrelated/component";

class SignupFilter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tab: "basic",
            strategy_tabs: "auto",
            advanced_tab: "",
            industry: null,
            slogans: [],
            related_industries: [],
            regions: [],
            regions_selected: [],
            regions_grid: {},
            ad_languages: [],
            interests: [],
            interests_selected: [],
            industries: [],
            industries_selected: [],
            behaviors: [],
            behaviors_selected: [],
            behavior_grid: {},
            vat: 0,
            currency: null,
            country: false,
            market: null,
            language: null,
            country_region: {},
            default_ad_language: {},
            lockin_plans: null,
            dropdown: false,
            dropdown_industry: false,
            search: "",
            searchInterest: "",
            searchIndustry: "",
            searchBehavior: "",
            budget: null,
            duration: null,
            durations: [],
            isLoading: true,
            targets: [],
            age_range: [],
            lang: null,
            regionLoader: false,
            service_fee_fixed: null,
            service_fee_percentage: null,
            error: false,
            reseller: false,
            inhouse: false,
            region_switch: false,
            related_open: false,
            count: 0,
            page: 1,
            keyword_languages: [],
            strategies: [],
            social_targeting: false
        };
        this._updateBudget = this._updateBudget.bind(this);
        this._updateNewBudget = this._updateNewBudget.bind(this);
        this._selectDuration = this._selectDuration.bind(this);
        this._updateSelectedRegions = this._updateSelectedRegions.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateData();
        this._updateTab();
        this._updateUser();

        if(window.innerWidth > 1050){
            this.setState({count: 30});
        }else{
            this.setState({count: 20});
        }

        //GOOGLE ANALYTICS
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactGA.pageview('/signup/filter');
            ReactGA4.send({ hitType: "pageview", page: "/signup/filter" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

    }

    _updateUser() {
        try {
            let user = userRegister.get();
            if (user) {
                this.setState({
                    reseller: user.reseller,
                    inhouse: user.inhouse
                });
            }
        } catch (e) {}
    }

    _updateData() {
        let stored_data = cartRegister.get();
        if (stored_data.admin_image) {
            if (!stored_data.admin_image.data_url && !stored_data.admin_image.web_url) {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/image");
            }
        }
        if (stored_data.industry && stored_data.channels && (stored_data.image || stored_data.admin_image) && (stored_data.quotes || stored_data.admin_quotes) && stored_data.budget && stored_data.plan) {
            this.setState({
                social_targeting: salesChannelRegister.get('social_targeting'),
                market: salesChannelRegister.get('market'),
                currency: salesChannelRegister.get('currency'),
                vat: salesChannelRegister.get('vat'),
                country_region: JSON.parse(salesChannelRegister.get('country_region')),
                default_language: salesChannelRegister.get('default_language'),
                ad_languages: JSON.parse(salesChannelRegister.get('ad_languages')),
                service_fee_percentage: stored_data.servicefee_percentage,
                service_fee_fixed: stored_data.servicefee_fixed,
                available_keyword_languages: JSON.parse(salesChannelRegister.get('keyword_languages')),
                keyword_languages: stored_data.keyword_languages ? stored_data.keyword_languages : [],
                industry: stored_data.industry,
                channels: stored_data.channels,
                //regions_selected: stored_data.regions ? stored_data.regions : [],
                industries_selected: stored_data.extra_industries ? stored_data.extra_industries : [],
                budget: stored_data.budget,
                related_industries: stored_data.related_industries ? stored_data.related_industries : [],
                interests_selected: stored_data.interests ? stored_data.interests : [],
                behaviors_selected: stored_data.behaviors ? stored_data.behaviors : [],
                duration: stored_data.duration,
                durations: JSON.parse(salesChannelRegister.get("durations")),
                optimization_goal: stored_data.crossroad === "instant"?2:1,
                lockin_plans: stored_data.lockin_plans ? stored_data.lockin_plans : null,
                language: stored_data.language ? stored_data.language : salesChannelRegister.get('default_ad_language'),
                selected_strategy: stored_data.strategy ? JSON.stringify(stored_data.strategy) : null,
                strategy_tabs: stored_data.strategy_tab ? stored_data.strategy_tab : "auto",
                plan: stored_data.plan,
                targets: stored_data.targets ? stored_data.targets : [{
                    title: this._renderText("item_38"),
                    selected: true,
                    value: "m"
                }, {
                    title: this._renderText("item_39"),
                    selected: true,
                    value: "f"
                }],
                age_range: stored_data.age_range ? stored_data.age_range : [18, 65]
            }, () => {

                this._updateSlogans();
                this._updateIndustries();
                this._updateRelatedIndustries(salesChannelRegister.get("market"), langRegister.lang(), this.state.industry.id);
                if (this.state.social_targeting) {
                this._updateFacebookTargetingBehavior();
                }
                this._updateFacebookTargetinInterests();
                this._updateStrategies(salesChannelRegister.get("market"), this.state.industry.id);

                //SET ADVANCED TAB DEFAULT
                if(Object.keys(this.state.channels).filter((item) => {
                    return this.state.budget[item].search && this.state.channels[item].selected
                }).length > 0){
                    this.setState({advanced_tab: "search"});
                }else{
                    this.setState({advanced_tab: "social"});
                }

                //CHECK IF RELATED AND OPEN LIST
                if(this.state.related_industries.length > 0){
                    this.setState({related_open: this.state.related_industries.filter((item) => {return item.selected}).length > 0});
                }

                //SET BUDGET AUTO
                if(this.state.budget){
                    for (var key in this.state.budget) {
                        this.state.budget[key].auto = true;
                    }
                }

                console.log(this.state.selected_strategy);

                //SET STRATEGY INPUT
                if(this.state.selected_strategy){
                    try {
                        if(!JSON.parse(this.state.selected_strategy).private){
                            this.setState({strategy_tabs: "manual"});
                        }else{
                            this.setState({strategy_tabs: "auto"});
                        }
                    }catch (e) {

                    }
                }else{
                    if(this.state.strategy_tabs === "auto"){
                        this.setState({strategy_tabs: "auto", selected_strategy: "-1"});
                    }
                }

                /*TEMPORARY REMOVE LATER*/
                try {
                    if (this.state.keyword_languages.length < 1) {
                        let market = salesChannelRegister.get('market');
                        let langs = [];
                        if(market === "se"){
                            langs.push('sv');
                        }else{
                            langs.push('en');
                        }
                        cartRegister.setKeywordLanguages(langs);
                        this.setState({keyword_languages: langs});
                    }
                } catch (e) {
                }
                /*TEMPORARY REMOVE LATER*/

            })
        } else {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
        }
    }

    _updateTab() {
        if (this.props.location.search === "?tab=advanced") {
            this.setState({tab: "advanced"});
        }
    }

    _updateBudget(value) {
        if (value) {
            this.setState({budget: value}, () => {
                cartRegister.setBudget(this.state.budget);
            });
        }
    }

    _updateRelatedIndustries(market, lang, industry) {
        if (this.state.related_industries.length > 0) {
            //this._updateRegions(this.state.market);
            this.setState({
                isLoading: false
            });
        } else {
            dataRegister.related(market, lang, industry).then((data) => {
                this.setState({
                    related_industries: data,
                    isLoading: false
                }, () => {
                    cartRegister.setRelated(data);
                    //this._updateRegions(this.state.market);
                });
            }, (error) => {
                this.setState({error: true});
            });
        }
    }

    _updateSelectedRegions(regions, grid, init_regions){
        this.setState({regions_selected: regions, regions_grid: grid}, () => {
            cartRegister.setRegions(this.state.regions_selected);
            cartRegister.setRegionsGrid(this.state.regions_grid);

            //SKIP UPDATING BUDGET WHEN REGIONS IS FIRST LOADED
            if(!init_regions){
                this._updateNewBudget();
            }

        });
    }

    _updateIndustries(){
        dataRegister.getIndustries(salesChannelRegister.get("market"), langRegister.lang(), this.state.searchIndustry, 20).then((response) => {
            this.setState({industries: response});
        }, (error) => {
            console.log(error);
        });
    }

    _updateStrategies(market, industry){
        if(market && industry){
            dataRegister.getIndustryStrategies(market, industry).then((response) => {
                if(!response.error){
                    this.state.strategies = response;
                    this.state.strategies.unshift({id: 0, name: this._renderText("item_62")});
                    this.setState({
                        strategies: this.state.strategies
                    });
                }
            }, (error) => {
                this.setState({
                    strategies: [{id: 0, name: this._renderText("item_62")}]
                });
            });
        }
    }

    _updateSlogans(){
        let cart = cartRegister.getCheckout();
        if(cart.target_slogans){
            this.setState({slogans: cart.target_slogans});
        }else{
            this.setState({slogansLoader: true});
            dataRegister.quotes(this.state.industry.id, this.state.market, langRegister.lang()).then((data) => {
                if(!data.errors){
                    data = data.filter((item) => {
                        return item.type === "target"
                    });
                    this.setState({slogans: data, slogansLoader: false});
                }
            }, (error) => {
                this.setState({slogansLoader: false, error: true});
            });
        }
    }

    _updateFacebookTargeting(type){
        dataRegister.facebookTargeting(this.state.market, type, this.state.searchInterest).then((data) => {
            if(!data.errors){
                let list = [];
                let exist = false;
                for(let i = 0; i < data.length; i++){
                    exist = false;
                    for(let m = 0; m < this.state.interests_selected.length; m++){
                        if(this.state.interests_selected[m].id === data[i].id){
                            exist = true;
                            break;
                        }
                    }
                    if(!exist){
                        list.push(data[i]);
                    }
                }
                this.setState({interests: list});
            }
        }, (error) => {});
    }

    _updateFacebookTargetinInterests(){
        dataRegister.facebookTargeting(this.state.market, "interest", this.state.industry.name).then((data) => {
            if(!data.errors){
                for(let i = 0; i < data.length; i++){
                    for(let m = 0; m < this.state.interests_selected.length; m++){
                        if(this.state.interests_selected[m].id === data[i].id){
                            data[i].selected = true;
                            break;
                        }
                    }
                }
                let object = {};
                object[this.state.industry.name] = data;
                this.setState({interests_grid: object, show_interests_switch: data.length > 0});
            }
        }, (error) => {});
    }

    _updateFacebookTargetingBehavior(){
        dataRegister.facebookTargeting(this.state.market, "behavior", "").then((data) => {
            if(!data.errors){
                for(let i = 0; i < this.state.behaviors_selected.length; i++){
                    for(let m = 0; m < data.length; m++){
                        if(this.state.behaviors_selected[i].id === data[m].id){
                            data[m].hide = true;
                            data[m].selected = true;
                            break;
                        }
                    }
                }
                this.setState({behaviors: data}, () => {
                    let object = {};
                    for(let i = 0; i < this.state.behaviors.length; i++){
                        if(object[this.state.behaviors[i].path[0]]){
                            object[this.state.behaviors[i].path[0]].push(this.state.behaviors[i]);
                        }else{
                            object[this.state.behaviors[i].path[0]] = [];
                            object[this.state.behaviors[i].path[0]].push(this.state.behaviors[i]);
                        }
                    }
                    this.setState({behavior_grid: object});
                });
            }
        }, (error) => {});
    }

    _updateNewBudget() {
        if (this.state.regions_selected.length > 0) {

            let regions = this.state.regions_selected
                .map(function (item) {
                    return item.id;
                }).join(",");

            let related = this.state.related_industries.filter((item) => {
                return item.selected
            }).map(function (item) {
                return item.id;
            }).join(",");

            if(this.state.industries_selected.length > 0){

                let extra_related = this.state.industries_selected.map(function (item) {
                    return item.id;
                }).join(",");

                if(this.state.related_industries.filter((item) => {
                    return item.selected
                }).length > 0){
                    related = related+","+extra_related;
                }else{
                    related = extra_related;
                }

            }

            let industry = this.state.industry.id;
            let market_code = this.state.market;
            let market_lang = this.state.default_language;
            let duration = this.state.duration;
            let optimization_goal = this.state.optimization_goal;
            let saleschannel = salesChannelRegister.get('name');

            dataRegister.budget(market_code, market_lang, saleschannel, industry, regions, related, duration, optimization_goal).then((data) => {
                if (!data.errors) {

                    let budget = {};

                    //REMOVE LOCKIN
                    if("lockin_plans" in data){
                        this.state.lockin_plans = data.lockin_plans;
                        delete data.lockin_plans;
                        //PARSE LOCKIN PLANS
                        let plans = [];
                        let biggest_plan = {months: 0, free_months: 0};
                        if(this.state.lockin_plans.months && Array.isArray(this.state.lockin_plans.months)){
                            for(let i = 0; i < this.state.lockin_plans.months.length; i++){
                                let free_months = 0;
                                if(this.state.lockin_plans.months[i] > 5 && this.state.lockin_plans.months[i] < 12){
                                    free_months = 1;
                                }else if(this.state.lockin_plans.months[i] > 11){
                                    free_months = 2;
                                }
                                //SET BIGGEST PLAN AS DEFAULT
                                if(biggest_plan.months < this.state.lockin_plans.months[i]){
                                    biggest_plan = {"months": this.state.lockin_plans.months[i], "free_months": free_months};
                                }
                                plans.push({"months": this.state.lockin_plans.months[i], "free_months": free_months})
                            }
                            cartRegister.lockinPlans(plans);
                            cartRegister.setLockinPlan(biggest_plan);
                        }
                    }

                    // REMOVE SERVICE_FEE PROPERTIES
                    if ("service_fee_percentage" in data) {
                        this.state.service_fee_percentage = data.service_fee_percentage;
                        delete data.service_fee_percentage;
                    }
                    if ("service_fee_fixed" in data) {
                        this.state.service_fee_fixed = data.service_fee_fixed;
                        delete data.service_fee_fixed;
                    }

                    //REMOVE BUDGET DURAION
                    if("campaign_duration" in data){
                        delete data.campaign_duration;
                    }

                    this.setState({
                        service_fee_fixed: this.state.service_fee_fixed,
                        service_fee_percentage: this.state.service_fee_percentage,
                        lockin_plans: this.state.lockin_plans
                    });

                    for (let channel in data) {
                        if (channel === "fb") {
                            channel = "facebook";
                            budget[channel] = this._reCalcBudgetTemp(JSON.parse(JSON.stringify(data)), "fb");
                        } else {
                            budget[channel] = this._reCalcBudgetTemp(JSON.parse(JSON.stringify(data)), channel);
                        }
                    }

                    this.setState({
                        budget: budget,
                        error: false,
                        isLoading: false,
                    }, () => {
                        cartRegister.setOfferServiceFeePercentage(this.state.service_fee_percentage);
                        cartRegister.setOfferServiceFeeFixed(this.state.service_fee_fixed);
                        cartRegister.setBudget(this.state.budget);
                    });

                } else {
                    this.setState({
                        error: true
                    });
                }
            }, (error) => {
                this.setState({error: true});
            });
        }
    }

    _reCalcBudgetTemp(data, channel) {

        //SET AUTO PROPERTY (ON)
        data[channel].auto = true;

        if(data[channel].social){
            data[channel].budget_available = data[channel].budget_cap;
            data[channel].budget = data[channel].budget_cap;
        }

        if(data[channel].budget_available > data[channel].budget_cap){
            data[channel].budget_available = data[channel].budget_cap;
            data[channel].budget = data[channel].budget_cap;
        }

        //SET INITIAL SPEND
        if (data[channel].budget_available > (data[channel].min_daily * this.state.duration)) {
            data[channel].spend = data[channel].min_daily * this.state.duration;
            data[channel].min_budget = data[channel].min_daily * this.state.duration;
            data[channel].budget = data[channel].budget_available;
        } else {
            data[channel].budget_available = data[channel].min_daily * this.state.duration;
            data[channel].spend = data[channel].min_daily * this.state.duration;
            data[channel].min_budget = data[channel].min_daily * this.state.duration;
            data[channel].budget = data[channel].min_daily * this.state.duration;
        }

        return data[channel];
    }

    _selectDuration(value){
        this.setState({duration: value, isLoading: this.state.regions_selected.length > 0}, () => {
            cartRegister.setDuration(this.state.duration);
            if (this.state.regions_selected.length > 0) {
                this._updateNewBudget(salesChannelRegister.get('market'), salesChannelRegister.get('default_language'), salesChannelRegister.get('name'), this.state.industry.id);
            }
        });
    }

    _selectRelatedIndustry(prop) {

        prop.selected = !prop.selected;
        this.setState({
            related_industries: this.state.related_industries
        }, () => {
            cartRegister.setRelated(this.state.related_industries);
            this._updateNewBudget();
        });

    }

    _selectSlogan(prop, reset) {
        if(!reset){
            if (prop.selected) {
                prop.selected = false;
            } else {
                this.state.slogans.map((item) => {
                    item.selected = false;
                });
                prop.selected = true;
            }
        }else{
            this.state.slogans.map((item) => {
                item.selected = false;
            });
        }
        this.setState({
            slogans: this.state.slogans
        }, () => {
            let targets = false;
            for (let i = 0; i < this.state.targets.length; i++) {
                if (!this.state.targets[i].selected) {
                    targets = true;
                }
            }
            if (this.state.keyword_languages.length > 1 || this.state.slogans.filter((item) => {
                return item.selected
            }).length > 0 || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || targets || this.state.interests_selected.length > 0) {
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
            } else {
                cartRegister.setPlan(marketRegister.lowPlan());
                this.setState({plan: marketRegister.lowPlan()});
            }
            cartRegister.setTargetSlogans(this.state.slogans);
        });
    }

    _selectTarget(prop, reset) {
        if(!reset){
            prop.selected = !prop.selected;
        }else{
            for (let i = 0; i < this.state.targets.length; i++) {
                this.state.targets[i].selected = true;
            }
            cartRegister.setTargets(null);
        }
        this.setState({targets: this.state.targets}, () => {
            let value = false;
            for (let i = 0; i < this.state.targets.length; i++) {
                if (!this.state.targets[i].selected) {
                    value = true;
                }
            }
            if (this.state.interests_selected.length > 0 || this.state.behaviors_selected.length > 0 || value || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || this.state.slogans.filter((item) => {
                return item.selected
            }).length > 0) {
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
                cartRegister.setTargets(this.state.targets);
            } else {
                cartRegister.setPlan(marketRegister.lowPlan());
                this.setState({plan: marketRegister.lowPlan()});
                cartRegister.setTargets(null);
            }
        });
    }

    _selectRange(value) {
        let targets = false;
        for (let i = 0; i < this.state.targets.length; i++) {
            if (!this.state.targets[i].selected) {
                targets = true;
            }
        }
        this.setState({age_range: this.state.age_range}, () => {
            if (this.state.interests_selected.length > 0 || this.state.behaviors_selected.length > 0 || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || targets || this.state.slogans.filter((item) => {
                return item.selected
            }).length > 0) {
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
                cartRegister.setAgeRange(this.state.age_range);
                cartRegister.setTargets(this.state.targets);
            } else {
                cartRegister.setPlan(marketRegister.lowPlan());
                this.setState({plan: marketRegister.lowPlan()});
                cartRegister.setAgeRange(null);
                cartRegister.setTargets(null);
            }
        })
    }

    _selectCountry() {
        let exist = false;
        let country = this.state.country_region;
        this.state.regions_selected = this.state.regions_selected.filter(function (item) {
            if (item.id !== country.id) {
                return item;
            } else {
                exist = true;
            }
        });
        if (!exist) {
            this.state.regions_selected.push(country);
        }
        this.setState({
            regions_selected: this.state.regions_selected
        }, () => {
            //this._updateRegions(this.state.market);
            this._updateNewBudget();
        });
    }

    _selectKeywordLanguage(item, reset) {
        let targets = false;
        let exist = false;
        if(!reset){
            exist = false;
            for (let i = 0; i < this.state.keyword_languages.length; i++) {
                if (this.state.keyword_languages[i] === item) {
                    this.state.keyword_languages.splice(i, 1);
                    exist = true;
                    break;
                }
            }
            if (!exist) {
                this.state.keyword_languages.push(item);
            }

            targets = false;
            for (let i = 0; i < this.state.targets.length; i++) {
                if (!this.state.targets[i].selected) {
                    targets = true;
                }
            }
        }else{
            this.state.keyword_languages = [];
        }
        if (this.state.keyword_languages.length > 1 || this.state.slogans.filter((item) => {
            return item.selected
        }).length > 0 || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || targets || this.state.interests_selected.length > 0) {
            cartRegister.setPlan(marketRegister.highPlan());
            this.setState({plan: marketRegister.highPlan()});
        } else {
            cartRegister.setPlan(marketRegister.lowPlan());
            this.setState({plan: marketRegister.lowPlan()});
        }

        this.setState({keyword_languages: this.state.keyword_languages}, () => {
            cartRegister.setKeywordLanguages(this.state.keyword_languages);
        });
    }

    _selectRegion(prop) {
        this.state.regions_selected.push(prop);
        this.setState({
            regions_selected: this.state.regions_selected,
            search: ""
        }, () => {
            //this._updateRegions(this.state.market);
            this._updateNewBudget();
        });
    }

    _selectInterest(prop, reset){
        if(!reset){
            this.state.interests_selected.push(prop);
            try {
                if (this.state.industry.name) {
                    let key = this.state.industry.name;
                    for (let i = 0; i < this.state.interests_grid[key].length; i++) {
                        if (this.state.interests_grid[key][i].id === prop.id) {
                            this.state.interests_grid[key][i].selected = true;
                        }
                    }
                }
            }catch (e) {}
        }else{
            this.state.interests_selected = [];
            try {
                if (this.state.industry.name) {
                    let key = this.state.industry.name;
                    for (let i = 0; i < this.state.interests_grid[key].length; i++) {
                        this.state.interests_grid[key][i].selected = false;
                    }
                }
            }catch (e) {}
        }
        this.setState({interests_selected: this.state.interests_selected, searchInterest: "", interests: []}, () => {
            if(!reset){
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
            }
            cartRegister.setInterests(this.state.interests_selected);
        });
    }

    _selectBehavior(prop, reset){
        if(!reset){
            this.state.behaviors_selected.push(prop);
            for (let i = 0; i < this.state.behaviors.length; i++) {
                if (this.state.behaviors[i].id === prop.id) {
                    this.state.behaviors[i].hide = true;
                    this.state.behaviors[i].selected = true;
                }
            }
        }else{
            this.state.behaviors_selected = [];
            for (let i = 0; i < this.state.behaviors.length; i++) {
                this.state.behaviors[i].selected = false;
            }
        }
        this.setState({behaviors_selected: this.state.behaviors_selected, searchBehavior: "", behaviors: this.state.behaviors}, () => {
            if(!reset){
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
            }
            cartRegister.setBehaviors(this.state.behaviors_selected);
        });
    }

    _selectIndustry(prop){
        this.state.industries_selected.push(prop);
        this.setState({industries_selected: this.state.industries_selected, searchIndustry: ""}, () => {
            cartRegister.setExtraIndustries(this.state.industries_selected);
            this._updateIndustries();
            this._updateNewBudget();
        });
    }

    _selectStrategy(prop){
        if(prop !== "-1"){
            prop = JSON.parse(prop);
            if(prop.id === 0){
                this.setState({strategy_tabs: "auto", dropdownStrategies: false, searchStrategies: null, selected_strategy: "-1", age_range: [18, 65]}, () => {
                    this._selectTarget(true, true);
                    this._selectKeywordLanguage(true, true);
                    this._selectSlogan(true, true);
                    this._selectBehavior(true, true);
                    this._selectInterest(true, true);
                    this._selectRange();
                    cartRegister.setStrategy(null);
                    cartRegister.setStrategyTab(this.state.strategy_tabs);
                });
            }else{
                this.setState({searchStrategies: prop.id, dropdownStrategies: false, selected_strategy: JSON.stringify(prop), age_range: [18, 65]}, () => {
                    cartRegister.setStrategy(prop);
                    this._selectTarget(true, true);
                    this._selectKeywordLanguage(true, true);
                    this._selectSlogan(true, true);
                    this._selectBehavior(true, true);
                    this._selectInterest(true, true);
                    this._selectRange();
                    try {
                        if(prop.data.additional_keyword_languages){
                            for(let i = 0; i < prop.data.additional_keyword_languages.google.length; i++){
                                this._selectKeywordLanguage(prop.data.additional_keyword_languages.google[i]);
                            }
                        }
                    }catch (e) {
                        console.log(e);
                    }
                    try {
                        if(prop.data.target_slogan){
                            for(let i = 0; i < this.state.slogans.length; i++){
                                if(+this.state.slogans[i].id === +prop.data.target_slogan){
                                    this.state.slogans[i].selected = false;
                                    this._selectSlogan(this.state.slogans[i]);
                                }
                            }
                        }
                    }catch (e) {
                        console.log(e);
                    }
                    try {
                        if(prop.data.facebook_demographics.gender){
                            for (let i = 0; i < this.state.targets.length; i++) {
                                this.state.targets[i].selected = false;
                            }
                            for(let i = 0; i < this.state.targets.length; i++){
                                if(this.state.targets[i].value === prop.data.facebook_demographics.gender){
                                    this._selectTarget(this.state.targets[i]);
                                }
                            }
                        }
                    }catch (e) {
                        console.log(e);
                    }
                    try {
                        if(prop.data.facebook_demographics.age_min && prop.data.facebook_demographics.age_max){
                            this.state.age_range = [];
                            this.state.age_range.push(prop.data.facebook_demographics.age_min);
                            this.state.age_range.push(prop.data.facebook_demographics.age_max);
                            this.setState({
                                age_range: this.state.age_range
                            }, () => {
                                console.log(this.state.age_range);
                                this._selectRange();
                            });
                        }
                    }catch (e) {
                        console.log(e);
                    }
                });
            }
        }
    }

    _removeRegion(prop) {
        this.setState({
            regions_selected: this.state.regions_selected.filter((item) => {
                return item.id !== prop.id
            })
        }, () => {
            //this._updateRegions(this.state.market);
            this._updateNewBudget();
        });
    }

    _removeInterest(prop) {
        this.setState({
            interests_selected: this.state.interests_selected.filter((item) => {
                return item.id !== prop.id
            })
        }, () => {
            if(this.state.industry.name){
                let key = this.state.industry.name;
                for(let i = 0; i < this.state.interests_grid[key].length; i++){
                    if(this.state.interests_grid[key][i].id === prop.id){
                        this.state.interests_grid[key][i].selected = false;
                    }
                }
            }
            let targets = false;
            for (let i = 0; i < this.state.targets.length; i++) {
                if (!this.state.targets[i].selected) {
                    targets = true;
                }
            }
            if (this.state.slogans.filter((item) => {
                return item.selected
            }).length > 0 || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || targets || this.state.interests_selected.length > 0 || this.state.behaviors_selected.length > 0) {
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
            } else {
                cartRegister.setPlan(marketRegister.lowPlan());
                this.setState({plan: marketRegister.lowPlan()});
                cartRegister.setTargets(null);
            }
            cartRegister.setInterests(this.state.interests_selected);
        });
    }

    _removeBehavior(prop) {
        this.setState({
            behaviors_selected: this.state.behaviors_selected.filter((item) => {
                return item.id !== prop.id
            })
        }, () => {
            for(let i = 0; i < this.state.behaviors.length; i++){
                if(this.state.behaviors[i].id === prop.id){
                    this.state.behaviors[i].hide = false;
                    this.state.behaviors[i].selected = false;
                }
            }
            let targets = false;
            for (let i = 0; i < this.state.targets.length; i++) {
                if (!this.state.targets[i].selected) {
                    targets = true;
                }
            }
            if (this.state.slogans.filter((item) => {
                return item.selected
            }).length > 0 || (this.state.age_range[0] !== 18 || this.state.age_range[1] !== 65) || targets || this.state.behaviors_selected.length > 0 || this.state.interests_selected.length > 0) {
                cartRegister.setPlan(marketRegister.highPlan());
                this.setState({plan: marketRegister.highPlan()});
            } else {
                cartRegister.setPlan(marketRegister.lowPlan());
                this.setState({plan: marketRegister.lowPlan()});
                cartRegister.setTargets(null);
            }
            cartRegister.setBehaviors(this.state.behaviors_selected);
        });
    }

    _removeIndustry(prop) {
        this.setState({
            industries_selected: this.state.industries_selected.filter((item) => {
                return item.id !== prop.id
            })
        }, () => {
            cartRegister.setExtraIndustries(this.state.industries_selected);
            this._updateNewBudget();
        });
    }

    _checkout() {
        /*
        if (this.state.tab === "basic" && Object.keys(this.state.channels).filter((item) => {
            return this.state.budget[item].social && this.state.channels[item].selected
        }).length > 0 && this.state.regions_selected.length > 0) {
            this.setState({tab: "advanced"});
        } else {
            if (this.state.regions_selected.length > 0 && this.state.targets.filter((item) => {
                return item.selected
            }).length > 0) {
                cartRegister.setAdLanguage(this.state.language);
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/budget");
            }
        }
        */

        let total_selected_industries = this.state.industries_selected.length + this.state.related_industries.filter((item) => {return item.selected}).length;

        if (this.state.regions_selected.length > 0 && this.state.targets.filter((item) => {
            return item.selected
        }).length > 0) {

        if (total_selected_industries > 7 && this.state.regions_selected.length <= 5 && !this.state.inhouse) {
            this.setState({
                to_many_related_modal: true,
                display_warning: 1
            })

        } else if (this.state.regions_selected.length > 5 && total_selected_industries <= 7 && !this.state.inhouse) {
            this.setState({
                to_many_related_modal: true,
                display_warning: 2
            })

        } else if (total_selected_industries > 7 && this.state.regions_selected.length > 5 && !this.state.inhouse) {
            this.setState({
                to_many_related_modal: true,
                display_warning: 3
            })

        } else {

            cartRegister.setAdLanguage(this.state.language);
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/budget");

        }
        }
    }

    _back() {
        /*
        if (this.state.tab === "advanced" && Object.keys(this.state.channels).filter((item) => {
            return this.state.budget[item].social && this.state.channels[item].selected
        }).length > 0) {
            this.setState({tab: "basic"});
        } else {
            cartRegister.setAdLanguage(this.state.language);
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/ads");
        }
        */
        cartRegister.setAdLanguage(this.state.language);
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/ads");
    }

    _filterRegions(search) {
        let industries = [];
        let exact = [];
        let first = [];
        let contains = [];
        let pattern = new RegExp('^' + search.toLowerCase());
        for (let i = 0; i < this.state.regions.length; i++) {
            if (this.state.regions[i].name.toLowerCase() === search.toLowerCase()) {
                exact.push(this.state.regions[i]);
            } else if (this.state.regions[i].name.toLowerCase().indexOf(search.toLowerCase()) !== 1 && !pattern.test(this.state.regions[i].name.toLowerCase())) {
                contains.push(this.state.regions[i]);
            } else if (pattern.test(this.state.regions[i].name.toLowerCase())) {
                first.push(this.state.regions[i]);
            }
        }
        industries = exact.concat(first, contains);
        return industries;
    }

    _filterIndustries(search) {
        try{
            let industries = [];
            let exact = [];
            let first = [];
            let contains = [];
            let pattern = new RegExp('^' + this.state.searchIndustry.toLowerCase());
            let list = JSON.parse(JSON.stringify(this.state.industries));

            for(let i = 0; i < list.length; i++){
                for(let m = 0; m < this.state.industries_selected.length; m++){
                    if(this.state.industries_selected[m].id === list[i].id){
                        list.splice(i, 1);
                    }
                }
                for(let n = 0; n < this.state.related_industries.length; n++){
                    if(this.state.related_industries[n].id === list[i].id){
                        list.splice(i, 1);
                    }
                }
                if(this.state.industry.id === list[i].id){
                    list.splice(i, 1);
                }
            }

            for (let i = 0; i < list.length; i++) {
                if (list[i].name.toLowerCase() === this.state.searchIndustry.toLowerCase()) {
                    exact.push(list[i]);
                } else if (list[i].name.toLowerCase().indexOf(this.state.searchIndustry.toLowerCase()) !== 1 && !pattern.test(list[i].name.toLowerCase())) {
                    contains.push(list[i]);
                } else if (pattern.test(list[i].name.toLowerCase())) {
                    first.push(list[i]);
                }
            }

            industries = exact.concat(first, contains);
            return industries;
        }catch (e) {
            return [];
        }
    }

    _renderAdLanguages(){
        for(let i = 0; i < this.state.ad_languages.length; i++){
            if(this.state.ad_languages[i].value === this.state.language){
                return(
                    <div className={Styles.checkMarksContainer}>
                        <div className={Styles.checkMarksContainerItem}>
                            <img src={require("../../assets/images/checkmark-disabled.svg")}
                                 className={Styles.checkMarksContainerItemIcon}/>
                            <div className={Styles.checkMarksContainerItemText}>
                                {this.state.ad_languages[i].title[langRegister.lang()]}
                            </div>
                        </div>
                    </div>
                )
            }else{
                return(
                    <div className={Styles.checkMarksContainer}>
                        <div className={Styles.checkMarksContainerItem}>
                            <img src={require("../../assets/images/checkmark_new.svg")}
                                 className={Styles.checkMarksContainerItemIcon}/>
                            <div className={Styles.checkMarksContainerItemText}>
                                {this.state.ad_languages[i].title[langRegister.lang()]}
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }

    _renderImpressionsBySpend() {
        let impressions = 0;
        if (this.state.budget) {
            if (this.state.regions_selected.length > 0) {
                for (let key in this.state.channels) {
                    if (this.state.channels[key].selected) {
                        impressions = impressions + (this.state.budget[key].spend / this.state.budget[key].cpi);
                    }
                }
                return Math.ceil(impressions);
            } else {
                return 0;
            }
        } else {
            return ("...");
        }
    }

    _renderLeadsBySpend() {
        let clicks = 0;
        if (this.state.budget) {
            if (this.state.regions_selected.length > 0) {
                for (let key in this.state.channels) {
                    if (this.state.channels[key].selected) {
                        clicks = clicks + (this.state.budget[key].spend / this.state.budget[key].cpc);
                    }
                }
                return Math.ceil(clicks);
            } else {
                return 0;
            }
        } else {
            return ("...");
        }
    }

    _renderPartialBudget() {
        if (this.state.budget && this.state.channels && this.state.regions_selected.length > 0) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }

            // IF FIXED FEE
            if (this.state.service_fee_fixed) {
                budget = budget + this.state.service_fee_fixed;
            }

            //IF PERCENTAGE SERVICE FEE
            if (this.state.service_fee_percentage) {
                budget = budget + this._renderPercentageFee();
            }

            /*
            //IF VAT
            if(this.state.vat){
                budget = budget + this._renderVat();
            }
            */

            return budget;
        }else{
            return 0;
        }
    }

    _renderPercentageFee() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }
            return budget * (this.state.service_fee_percentage / 100);
        }
    }

    _renderVat() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }

            // IF FIXED FEE
            if (this.state.service_fee_fixed) {
                budget = budget + this.state.service_fee_fixed;
            }

            //IF PERCENTAGE SERVICE FEE
            if (this.state.service_fee_fixed) {
                budget = budget + this._renderPercentageFee();
            }

            return budget * (this.state.vat / 100);
        }
    }

    renderKeywordLanguages() {
        let list = [];
        try {
            if (this.state.available_keyword_languages.google && this.state.available_keyword_languages.bing) {
                list = this.state.available_keyword_languages.google.concat(this.state.available_keyword_languages.bing);
                const final = [];
                list.map((e, i) => !final.includes(e) && final.push(e));
                list = final;
            } else if (this.state.available_keyword_languages.google && !this.state.available_keyword_languages.bing) {
                list = this.state.available_keyword_languages.google;
            } else if (!this.state.available_keyword_languages.google && this.state.available_keyword_languages.bing) {
                list = this.state.available_keyword_languages.bing;
            }

            for (let i = 0; i < list.length; i++) {
                try {
                    list[i] = this.renderKeywordLanguageTitle(list[i]);
                } catch (e) {
                }
            }

            return list

        } catch (e) {
            return list;
        }
    }

    renderKeywordLanguageAvailable(item) {
        let items = {
            'en': {'en': 'English', 'sv': 'Engelska'},
            'sv': {'en': 'Swedish', 'sv': 'Svenska'}
        };
        return items[item];
    }

    renderKeywordLanguage(item) {
        try {
            let selected = false;
            for (let i = 0; i < this.state.keyword_languages.length; i++) {
                if (this.state.keyword_languages[i] === item) {
                    selected = true;
                    break;
                }
            }
            return selected;
        } catch (e) {}
    }

    renderKeywordLanguageTitle(item) {
        let items = {
            'en': {'en': 'English', 'sv': 'Engelska', 'code': 'en'},
            'ar': {'en': 'Arabic', 'sv': 'Arabiska', 'code': 'ar'},
            'fi': {'en': 'Finnish', 'sv': 'Finska', 'code': 'fi'},
            'de': {'en': 'German', 'sv': 'Tyska', 'code': 'de'},
            'zh': {'en': 'Chinese', 'sv': 'Kinesiska', 'code': 'zh'},
            'tr': {'en': 'Turkish', 'sv': 'Turkiska', 'code': 'tr'},
            'es': {'en': 'Spanish', 'sv': 'Spanska', 'code': 'es'},
            'el': {'en': 'Greek', 'sv': 'Grekiska', 'code': 'el'},
            'sv': {'en': 'Swedish', 'sv': 'Svenska', 'code': 'sv'},
            'cs': {'en': 'Czech', 'sv': 'Tjeckiska', 'code': 'cs'},
            'da': {'en': 'Danish', 'sv': 'Danska', 'code': 'da'},
            'mt': {'en': 'Maltese', 'sv': 'Maltesiska', 'code': 'mt'},
            'hr': {'en': 'Croatian', 'sv': 'Kroatiska', 'code': 'hr'},
            'pa': {'en': 'Punjabi', 'sv': 'Punjabi', 'code': 'pa'},
            'fr': {'en': 'French', 'sv': 'Franska', 'code': 'fr'},
            'nl': {'en': 'Dutch', 'sv': 'Holländska', 'code': 'nl'},
            'ko': {'en': 'Korean', 'sv': 'Koreanska', 'code': 'ko'},
            'hi': {'en': 'Hindi', 'sv': 'Hindi', 'code': 'hi'},
            'pt': {'en': 'Portuguese', 'sv': 'Portugisiska', 'code': 'pt'},
            'ur': {'en': 'Urdu', 'sv': 'Urdu', 'code': 'ur'},
            'it': {'en': 'Italian', 'sv': 'Italienska', 'code': 'it'},
            'ru': {'en': 'Russian', 'sv': 'Ryska', 'code': 'ru'},
            'pl': {'en': 'Polish', 'sv': 'Polska', 'code': 'pl'},
            'ja': {'en': 'Japanese', 'sv': 'Japanska', 'code': 'ja'},
            'sr': {'en': 'Serbian', 'sv': 'Serbiska', 'code': 'sr'},
            'ms': {'en': 'Malay', 'sv': 'Malay', 'code': 'ms'}
        };
        try {
            return items[item];
        } catch (e) {
            return item;
        }
    }

    renderKeywordLanguageDisabled(item) {
        let items = {};
        let market = salesChannelRegister.get('market');
        if(market === "se"){
            items = {sv: 'sv'};
        }else{
            items = {en: 'en'};
        }
        return items[item];
    }

    _renderInterestPath(path){
        let string = "";
        for(let i = 0; i < path.length - 1; i++){
            if(i !== path.length - 2){
                string = string + path[i] + " - ";
            }else{
                string = string + path[i];
            }
        }
        return string;
    }

    _renderStrategyFilter(strategy){
        try {
            return JSON.parse(strategy).name;
        }catch (e) {

        }
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("signup-filter", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupTwo history={this.props.history} props={this.props} step={2}/>
                {
                    this.state.to_many_related_modal &&
                    <ModalMaxRelated display_warning={this.state.display_warning} setLeave={() => {
                        this.setState({
                            to_many_related_modal: false
                        })
                    }}/>
                }
                {
                    this.state.industry && this.state.channels && this.state.regions && this.state.budget && this.state.market && !this.state.isLoading && this.state.plan && this.state.currency && !this.state.error &&
                    <div className={Styles.containerOuter}>
                        <div className={Styles.container}>
                            <div className={cx(Styles.title)}>
                                {this._renderText("item_1")}
                            </div>
                            <div className={Styles.containerInner}>
                                <div className={Styles.left}>
                                    {
                                        <div className={
                                            cx(Styles.tabsContainer,
                                                {
                                                    [Styles.tabsContainerBasic]: this.state.tab === "basic" && Object.keys(this.state.channels).filter((item) => {
                                                        return this.state.budget[item].social && this.state.channels[item].selected
                                                    }).length > 0 && Object.keys(this.state.channels).filter((item) => {
                                                        return this.state.budget[item].search && this.state.channels[item].selected
                                                    }).length > 0,
                                                    [Styles.tabsContainerNoExtra]: Object.keys(this.state.channels).filter((item) => {
                                                        return this.state.budget[item].social && this.state.channels[item].selected
                                                    }).length < 1 || Object.keys(this.state.channels).filter((item) => {
                                                        return this.state.budget[item].search && this.state.channels[item].selected
                                                    }).length < 1
                                                })
                                        }>
                                            <div onClick={() => this.setState({tab: "basic"})} className={
                                                cx(Styles.tabsContainerItem,
                                                    {
                                                        [Styles.tabsContainerItemActive]: this.state.tab === "basic",
                                                    })
                                            }>
                                                {this._renderText("item_2")}
                                            </div>
                                            <div onClick={() => this.setState({tab: "advanced"})} className={
                                                cx(Styles.tabsContainerItem,
                                                    {
                                                        [Styles.tabsContainerItemActive]: this.state.tab === "advanced",
                                                    })
                                            }>
                                                {this._renderText("item_3")}
                                            </div>
                                        </div>
                                    }
                                    {
                                        this.state.tab === "advanced" && Object.keys(this.state.channels).filter((item) => {
                                            return this.state.budget[item].social && this.state.channels[item].selected
                                        }).length > 0 && Object.keys(this.state.channels).filter((item) => {
                                            return this.state.budget[item].search && this.state.channels[item].selected
                                        }).length > 0 && this.state.strategy_tabs === "manual" &&
                                        <div className={Styles.tabsContainerOpposite}>
                                            {
                                                <div onClick={() => this.setState({advanced_tab: "search"})} className={
                                                    cx(Styles.tabsContainerItemOpposite,
                                                        {
                                                            [Styles.tabsContainerItemActive]: this.state.advanced_tab === "search",
                                                        })
                                                }>
                                                    {this._renderText("item_51")}
                                                </div>
                                            }
                                            {
                                                <div onClick={() => this.setState({advanced_tab: "social"})} className={
                                                    cx(Styles.tabsContainerItemOpposite,
                                                        {
                                                            [Styles.tabsContainerItemActive]: this.state.advanced_tab === "social",
                                                        })
                                                }>
                                                    {this._renderText("item_50")}
                                                </div>
                                            }
                                        </div>
                                    }
                                    {
                                        this.state.tab === "advanced" && this.state.strategy_tabs === "auto" &&
                                        <div className={Styles.stategies}>
                                            <div className={Styles.stategiesItem}>
                                                <div onClick={() => this.setState({strategy_tabs: "auto", selected_strategy: "-1"}, () => {
                                                    this._selectStrategy(JSON.stringify({id: 0}));
                                                    cartRegister.setStrategyTab("auto");
                                                    cartRegister.setStrategy(null);
                                                })} className={
                                                    cx(Styles.stategiesItemInner,
                                                        {
                                                            [Styles.stategiesItemInnerActive]: this.state.strategy_tabs === "auto" && this.state.selected_strategy === "-1",
                                                        })
                                                }>
                                                    <div className={Styles.stategiesItemInnerTop}>
                                                        <div className={
                                                            cx(Styles.stategiesItemInnerTopDot,
                                                                {
                                                                    [Styles.stategiesItemInnerTopDotActive]: this.state.strategy_tabs === "auto" && this.state.selected_strategy === "-1",
                                                                })
                                                        }>
                                                            {
                                                                this.state.strategy_tabs === "auto" && this.state.selected_strategy === "-1" &&
                                                                <img className={Styles.stategiesItemInnerTopDotCheckmark}
                                                                     src={require("../../assets/images/checkmark_icon.svg")}/>
                                                            }
                                                        </div>
                                                        <div className={
                                                            cx(Styles.stategiesItemInnerTopTitle,
                                                                {
                                                                    [Styles.stategiesItemInnerTopTitleActive]: this.state.strategy_tabs === "auto" && this.state.selected_strategy === "-1",
                                                                })
                                                        }>
                                                            {this._renderText("item_57")}{" "}<span
                                                            className={Styles.stategiesItemInnerTopSubtitle}>{this._renderText("item_58")}</span>
                                                        </div>
                                                    </div>
                                                    <div className={Styles.stategiesItemInnerBottom}>
                                                        <div className={Styles.stategiesItemInnerBottomText}>
                                                            {this._renderText("item_59")}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={Styles.stategiesItem}>
                                                <div onClick={() => this.setState({strategy_tabs: "manual", selected_strategy: "-1"}, () => {
                                                    cartRegister.setStrategy(null);
                                                    cartRegister.setStrategyTab("manual");
                                                })} className={
                                                    cx(Styles.stategiesItemInner,
                                                        {
                                                            [Styles.stategiesItemInnerActive]: false,
                                                        })
                                                }>
                                                    <div className={Styles.stategiesItemInnerTop}>
                                                        <div className={
                                                            cx(Styles.stategiesItemInnerTopDot,
                                                                {
                                                                    [Styles.stategiesItemInnerTopDotActive]: false,
                                                                })
                                                        }/>
                                                        <div className={
                                                            cx(Styles.stategiesItemInnerTopTitle,
                                                                {
                                                                    [Styles.stategiesItemInnerTopTitleActive]: false,
                                                                })
                                                        }>
                                                            {this._renderText("item_60")}
                                                        </div>
                                                    </div>
                                                    <div className={Styles.stategiesItemInnerBottom}>
                                                        <div className={Styles.stategiesItemInnerBottomText}>
                                                            {this._renderText("item_61")}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {
                                                false &&
                                                this.state.strategies.map((item) => {
                                                    if(item.private){
                                                        return(
                                                            <div className={Styles.stategiesItem}>
                                                                <div onClick={() => {this._selectStrategy(JSON.stringify(item))}} className={
                                                                    cx(Styles.stategiesItemInner,
                                                                        {
                                                                            [Styles.stategiesItemInnerActive]: JSON.stringify(item) === this.state.selected_strategy,
                                                                        })
                                                                }>
                                                                    <div className={Styles.stategiesItemInnerTop}>
                                                                        <div className={
                                                                            cx(Styles.stategiesItemInnerTopDot,
                                                                                {
                                                                                    [Styles.stategiesItemInnerTopDotActive]: JSON.stringify(item) === this.state.selected_strategy,
                                                                                })
                                                                        }>
                                                                            {
                                                                                JSON.stringify(item) === this.state.selected_strategy &&
                                                                                <img className={Styles.stategiesItemInnerTopDotCheckmark}
                                                                                     src={require("../../assets/images/checkmark_icon.svg")}/>
                                                                            }
                                                                        </div>
                                                                        <div className={
                                                                            cx(Styles.stategiesItemInnerTopTitle,
                                                                                {
                                                                                    [Styles.stategiesItemInnerTopTitleActive]: JSON.stringify(item) === this.state.selected_strategy,
                                                                                })
                                                                        }>
                                                                            {item.name}
                                                                        </div>
                                                                    </div>
                                                                    <div className={Styles.stategiesItemInnerBottom}>
                                                                        <div className={Styles.stategiesItemInnerBottomText}>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                    }
                                    {
                                        this.state.tab === "advanced" && this.state.strategy_tabs === "manual" &&
                                        <div>
                                            {
                                                <div className={
                                                    cx(Styles.dropdown,
                                                        {
                                                            [Styles.dropdownError]: false,
                                                            [Styles.dropdownDisabled]: false,
                                                            /*[Styles.dropdownSelected]: !this.state.dropdowns[key].disabled && this.renders.dropdownValue(this.state.dropdowns[key].value),*/
                                                        })
                                                }>
                                                    <select
                                                        value={this.state.selected_strategy}
                                                        className={Styles.dropdownSelection}
                                                        onChange={(event) => {
                                                            this._selectStrategy(event.target.value);
                                                            event.target.blur();
                                                        }}
                                                    >
                                                        <option value="-1">{this._renderText("item_56")}</option>
                                                        {
                                                            this.state.strategies.map((item) => {
                                                                if(!item.private){
                                                                    return (
                                                                        <option className={Styles.dropdownSelectionOption} value={JSON.stringify(item)}>{item.name}</option>
                                                                    )
                                                                }
                                                            })
                                                        }
                                                    </select>
                                                    {
                                                        (!this.state.selected_strategy || this.state.selected_strategy === "-1") &&
                                                        <div className={Styles.dropdownText}>
                                                            {this._renderText("item_56")}
                                                        </div>
                                                    }
                                                    {
                                                        this.state.selected_strategy !== "-1" && this.state.selected_strategy &&
                                                        <div className={Styles.dropdownText}>
                                                            {this._renderStrategyFilter(this.state.selected_strategy)}
                                                        </div>
                                                    }
                                                    {
                                                        <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" &&
                                                <div className={cx(Styles.subTitle, Styles.subTitleLast)}>
                                                    {this._renderText("item_27")}
                                                    {
                                                        false &&
                                                        <img src={require("../../assets/images/info_icon.svg")}
                                                             className={Styles.subTitleIcon}/>
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" && !this.state.social_targeting &&
                                                <div className={Styles.checkMarksContainer}>
                                                    {
                                                        this.state.targets.map((prop, i) => {
                                                            return (
                                                                <div key={i}
                                                                     className={Styles.checkMarksContainerItem}>
                                                                    {
                                                                        prop.selected &&
                                                                        <img
                                                                            src={require("../../assets/images/checkmark-disabled.svg")}
                                                                            className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    <div
                                                                        className={Styles.checkMarksContainerItemText}>
                                                                        {prop.title}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" && this.state.social_targeting &&
                                                <div className={Styles.checkMarksContainer}>
                                                    {
                                                        this.state.targets.map((prop, i) => {
                                                            return (
                                                                <div onClick={() => this._selectTarget(prop)} key={i}
                                                                     className={Styles.checkMarksContainerItem}>
                                                                    {
                                                                        !prop.selected &&
                                                                        <img
                                                                            src={require("../../assets/images/checkmark_new.svg")}
                                                                            className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    {
                                                                        prop.selected &&
                                                                        <img
                                                                            src={require("../../assets/images/square_checkmark_active.svg")}
                                                                            className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    <div
                                                                        className={Styles.checkMarksContainerItemText}>
                                                                        {prop.title}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" &&
                                                <div className={Styles.subTitle}>
                                                    {this._renderText("item_28")}
                                                    {
                                                        false &&
                                                        <img src={require("../../assets/images/info_icon.svg")}
                                                             className={Styles.subTitleIcon}/>
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" &&
                                                <div className={Styles.sliderRangeContainer}>
                                                    <div className={Styles.sliderRangeContainerValue}>
                                                        <input readOnly={true} value={this.state.age_range[0]}
                                                               className={Styles.sliderRangeContainerValueInput}/>
                                                    </div>
                                                    <div className={Styles.sliderRangeContainerSlider}>
                                                        <Range
                                                            disabled={!this.state.social_targeting}
                                                            defaultValue={[18, 65]}
                                                            trackStyle={[{backgroundColor: '#41CBC7'}]}
                                                            min={18}
                                                            max={65}
                                                            value={this.state.age_range}
                                                            onChange={(value) => {
                                                                this.state.age_range = value;
                                                                this._selectRange()
                                                            }}
                                                        />
                                                    </div>
                                                    <div className={Styles.sliderRangeContainerValue}>
                                                        <input readOnly={true} value={this.state.age_range[1]>64?this.state.age_range[1] + "+":this.state.age_range[1]} className={Styles.sliderRangeContainerValueInput}/>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) &&
                                                <div className={Styles.subTitle}>
                                                    <div className={Styles.subTitleLeft}>
                                                        {this._renderText("item_46")}
                                                    </div>
                                                    {
                                                        this.state.show_interests_switch && false &&
                                                        <div className={Styles.subTitleRight}>
                                                            {
                                                                <img
                                                                     className={Styles.subTitleRightIcon}
                                                                     src={require("../../assets/images/search_icon3.svg")}/>
                                                            }
                                                            {
                                                                this.state.interests_switch &&
                                                                <img onClick={() => {this.setState({interests_switch: false})}}
                                                                     className={Styles.subTitleRightSwitch}
                                                                     src={require("../../assets/images/push_black_on.svg")}/>
                                                            }
                                                            {
                                                                !this.state.interests_switch &&
                                                                <img onClick={() => {this.setState({interests_switch: true})}}
                                                                     className={Styles.subTitleRightSwitch}
                                                                     src={require("../../assets/images/push_black_off.svg")}/>
                                                            }
                                                            {
                                                                <img
                                                                     className={Styles.subTitleRightIcon}
                                                                     src={require("../../assets/images/list_icon.svg")}/>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && !this.state.interests_switch &&
                                                <div className={Styles.inputContainer}>
                                                    {
                                                        this.state.regionLoader &&
                                                        <div className={Styles.inputContainerLoader}>
                                                            <BeatLoader size={15} color={'#41CBC7'} loading={true}/>
                                                        </div>
                                                    }
                                                    <input onFocus={() => this.setState({dropdown: true})}
                                                           onBlur={() => this.setState({dropdown: false})}
                                                           value={this.state.searchInterest}
                                                           onChange={(event) => {
                                                               this.setState({searchInterest: event.target.value}, () => {
                                                                   this._updateFacebookTargeting("interest")
                                                               })
                                                           }}
                                                           placeholder={this._renderText("item_47")}
                                                           className={
                                                               cx(Styles.input, Styles.inputLong)
                                                           }
                                                    />
                                                    {
                                                        this.state.dropdown && this.state.interests.length > 0 &&
                                                        <div className={cx(Styles.inputDropdown, Styles.inputDropdownLong)}>
                                                            {
                                                                this.state.interests.map((prop, key) => {
                                                                    return (
                                                                        <div key={key}
                                                                             onMouseDown={() => this._selectInterest(prop)}
                                                                             className={cx(Styles.inputDropdownItem, Styles.inputDropdownItemExtraSpace)}>
                                                                            <div>
                                                                                {prop.name}
                                                                            </div>
                                                                            <div className={Styles.inputDropdownItemDescripton}>{this._renderInterestPath(prop.path)}</div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && !this.state.interests_switch &&
                                                <div className={Styles.regionsContainer}>
                                                    {
                                                        this.state.interests_selected.map((prop, i) => {
                                                            return (
                                                                <div key={i} className={Styles.regionsContainerItem}>
                                                                    <div className={Styles.regionsContainerItemTitle}>
                                                                        {prop.name}
                                                                    </div>
                                                                    <img onClick={() => this._removeInterest(prop)}
                                                                         src={require("../../assets/images/small_cross_white.png")}
                                                                         className={Styles.regionsContainerItemIcon}
                                                                    />
                                                                </div>
                                                            )

                                                        })
                                                    }
                                                </div>
                                            }
                                            {
                                                false &&
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && this.state.interests_switch && this.state.social_targeting &&
                                                <div>
                                                    {
                                                        Object.keys(this.state.interests_grid).map((key, i) => {
                                                            return(
                                                                <div>
                                                                    {
                                                                        <div className={Styles.subTitleSmall}>
                                                                            <div className={Styles.subTitleLeft}>
                                                                                {key}
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    <div className={Styles.checkMarksContainer}>
                                                                        {
                                                                            this.state.interests_grid[key].map((prop, i) => {
                                                                                return (
                                                                                    <div key={i} className={Styles.checkMarksContainerItemSmall}>
                                                                                        {
                                                                                            !prop.selected &&
                                                                                            <img onClick={() => this._selectInterest(prop, key)}
                                                                                                 src={require("../../assets/images/checkmark_new.svg")}
                                                                                                 className={Styles.checkMarksContainerItemIcon}/>
                                                                                        }
                                                                                        {
                                                                                            prop.selected &&
                                                                                            <img onClick={() => this._removeInterest(prop, key)}
                                                                                                 src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                                 className={Styles.checkMarksContainerItemIcon}/>
                                                                                        }
                                                                                        <div onClick={() => {
                                                                                            if(prop.selected){
                                                                                                this._removeInterest(prop, key)
                                                                                            }else{
                                                                                                this._selectInterest(prop, key)
                                                                                            }
                                                                                        }} className={Styles.checkMarksContainerItemText}>
                                                                                            {prop.name}
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && this.state.social_targeting &&
                                                <div className={Styles.subTitle}>
                                                    <div className={Styles.subTitleLeft}>
                                                        {this._renderText("item_52")}
                                                    </div>
                                                    <div className={Styles.subTitleRight}>
                                                        {
                                                            <img
                                                                 className={Styles.subTitleRightIcon}
                                                                 src={require("../../assets/images/search_icon3.svg")}/>
                                                        }
                                                        {
                                                            this.state.behaviors_switch &&
                                                            <img onClick={() => {this.setState({behaviors_switch: false})}}
                                                                 className={Styles.subTitleRightSwitch}
                                                                 src={require("../../assets/images/push_black_on.svg")}/>
                                                        }
                                                        {
                                                            !this.state.behaviors_switch &&
                                                            <img onClick={() => {this.setState({behaviors_switch: true})}}
                                                                 className={Styles.subTitleRightSwitch}
                                                                 src={require("../../assets/images/push_black_off.svg")}/>
                                                        }
                                                        {
                                                            <img
                                                                 className={Styles.subTitleRightIcon}
                                                                 src={require("../../assets/images/list_icon.svg")}/>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && !this.state.behaviors_switch && this.state.social_targeting &&
                                                <div className={Styles.inputContainer}>
                                                    <input onFocus={() => this.setState({dropdownBehavior: true})}
                                                           onBlur={() => this.setState({dropdownBehavior: false})}
                                                           value={this.state.searchBehavior}
                                                           onChange={(event) => {
                                                               this.setState({searchBehavior: event.target.value})
                                                           }}
                                                           placeholder={this._renderText("item_53")}
                                                           className={
                                                               cx(Styles.input, Styles.inputLong)
                                                           }
                                                    />
                                                    {
                                                        this.state.dropdownBehavior && this.state.behaviors.length > 0 &&
                                                        <div className={cx(Styles.inputDropdown, Styles.inputDropdownLong)}>
                                                            {
                                                                this.state.behaviors.filter((item) => {
                                                                    return item.name.toLowerCase().indexOf(this.state.searchBehavior.toLowerCase()) !== -1 && !item.hide
                                                                }).map((prop, key) => {
                                                                    return (
                                                                        <div key={key}
                                                                             onMouseDown={() => this._selectBehavior(prop)}
                                                                             className={cx(Styles.inputDropdownItem, Styles.inputDropdownItemExtraSpace)}>
                                                                            <div>
                                                                                {prop.name}
                                                                            </div>
                                                                            <div className={Styles.inputDropdownItemDescripton}>{prop.description}</div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && !this.state.behaviors_switch && this.state.social_targeting &&
                                                <div className={Styles.regionsContainer}>
                                                    {
                                                        this.state.behaviors_selected.map((prop, i) => {
                                                            return (
                                                                <div key={i} className={Styles.regionsContainerItem}>
                                                                    <div className={Styles.regionsContainerItemTitle}>
                                                                        {prop.name}
                                                                    </div>
                                                                    <img onClick={() => this._removeBehavior(prop)}
                                                                         src={require("../../assets/images/small_cross_white.png")}
                                                                         className={Styles.regionsContainerItemIcon}
                                                                    />
                                                                </div>
                                                            )

                                                        })
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].social && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "social" && (this.state.reseller || this.state.inhouse) && this.state.behaviors_switch && this.state.social_targeting &&
                                                <div>
                                                    {
                                                        Object.keys(this.state.behavior_grid).map((key, i) => {
                                                            return(
                                                                <div>
                                                                    {
                                                                        <div className={Styles.subTitleSmall}>
                                                                            <div className={Styles.subTitleLeft}>
                                                                                {key}
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    <div className={Styles.checkMarksContainer}>
                                                                        {
                                                                            this.state.behavior_grid[key].map((prop, i) => {
                                                                                return (
                                                                                    <div key={i} className={Styles.checkMarksContainerItemSmall}>
                                                                                        {
                                                                                            !prop.selected &&
                                                                                            <img onClick={() => this._selectBehavior(prop)}
                                                                                                 src={require("../../assets/images/checkmark_new.svg")}
                                                                                                 className={Styles.checkMarksContainerItemIcon}/>
                                                                                        }
                                                                                        {
                                                                                            prop.selected &&
                                                                                            <img onClick={() => this._removeBehavior(prop)}
                                                                                                 src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                                 className={Styles.checkMarksContainerItemIcon}/>
                                                                                        }
                                                                                        <div onClick={() => {
                                                                                            if(prop.selected){
                                                                                                this._removeBehavior(prop)
                                                                                            }else{
                                                                                                this._selectBehavior(prop)
                                                                                            }
                                                                                        }} className={Styles.checkMarksContainerItemText}>
                                                                                            {prop.name}
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].search && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "search" &&
                                                <div className={cx(Styles.subTitle, Styles.subTitleLast)}>
                                                    {this._renderText("item_54")}
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].search && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "search" &&
                                                <div className={Styles.checkMarksContainer}>
                                                    {
                                                        this.renderKeywordLanguages()
                                                            .sort(function (a, b) {
                                                                try {
                                                                    if (a[langRegister.lang()] < b[langRegister.lang()]) {
                                                                        return -1;
                                                                    }
                                                                    if (a[langRegister.lang()] > b[langRegister.lang()]) {
                                                                        return 1;
                                                                    }
                                                                    return 0;
                                                                } catch (e) {
                                                                    return 0;
                                                                }
                                                            }).map((prop, i) => {
                                                            return (
                                                                <div key={i} className={Styles.checkMarksContainerItem}>
                                                                    {
                                                                        !this.renderKeywordLanguage(prop.code) && !this.renderKeywordLanguageDisabled(prop.code) &&
                                                                        <img
                                                                            onClick={() => this._selectKeywordLanguage(prop.code)}
                                                                            src={require("../../assets/images/checkmark_new.svg")}
                                                                            className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    {
                                                                        this.renderKeywordLanguage(prop.code) && !this.renderKeywordLanguageDisabled(prop.code) &&
                                                                        <img
                                                                            onClick={() => this._selectKeywordLanguage(prop.code)}
                                                                            src={require("../../assets/images/square_checkmark_active.svg")}
                                                                            className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    {
                                                                        this.renderKeywordLanguageDisabled(prop.code) &&
                                                                        <img
                                                                            src={require("../../assets/images/checkmark-disabled.svg")}
                                                                            className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    <div onClick={() => {
                                                                        if (!this.renderKeywordLanguageDisabled(prop.code)) {
                                                                            this._selectKeywordLanguage(prop.code)
                                                                        }
                                                                    }}
                                                                         className={Styles.checkMarksContainerItemText}>
                                                                        {prop[langRegister.lang()]}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].search && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "search" &&
                                                <div className={Styles.subTitle}>
                                                    {this._renderText("item_45")}
                                                </div>
                                            }
                                            {
                                                Object.keys(this.state.channels).filter((item) => {
                                                    return this.state.budget[item].search && this.state.channels[item].selected
                                                }).length > 0 && this.state.advanced_tab === "search" &&
                                                <div className={Styles.checkMarksContainer}>
                                                    {
                                                        this.state.slogans.map((prop, i) => {
                                                            return (
                                                                <div key={i} className={Styles.checkMarksContainerItem}>
                                                                    {
                                                                        !prop.selected &&
                                                                        <img onClick={() => this._selectSlogan(prop)}
                                                                             src={require("../../assets/images/checkmark_new.svg")}
                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    {
                                                                        prop.selected &&
                                                                        <img onClick={() => this._selectSlogan(prop)}
                                                                             src={require("../../assets/images/square_checkmark_active.svg")}
                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    <div onClick={() => this._selectSlogan(prop)}
                                                                         className={Styles.checkMarksContainerItemText}>
                                                                        {prop.slogan}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                    {
                                        this.state.tab === "basic" &&
                                        <div>
                                            <div className={
                                                cx(Styles.subTitle)
                                            }>
                                                {this._renderText("item_31")}
                                            </div>
                                            {
                                                this._renderAdLanguages()
                                            }
                                            <div className={Styles.subTitle}>
                                                <div className={Styles.subTitleLeft}>
                                                    {this._renderText("item_6")}
                                                </div>
                                                <div className={Styles.subTitleRight}>
                                                    {
                                                        <img
                                                             className={Styles.subTitleRightIcon}
                                                             src={require("../../assets/images/search_icon3.svg")}/>
                                                    }
                                                    {
                                                        this.state.region_switch &&
                                                        <img onClick={() => {this.setState({region_switch: false})}}
                                                             className={Styles.subTitleRightSwitch}
                                                             src={require("../../assets/images/push_black_on.svg")}/>
                                                    }
                                                    {
                                                        !this.state.region_switch &&
                                                        <img onClick={() => {this.setState({region_switch: true})}}
                                                             className={Styles.subTitleRightSwitch}
                                                             src={require("../../assets/images/push_black_off.svg")}/>
                                                    }
                                                    {
                                                        <img
                                                             className={Styles.subTitleRightIcon}
                                                             src={require("../../assets/images/list_icon.svg")}/>
                                                    }
                                                </div>
                                            </div>
                                            {
                                                this.state.inhouse &&
                                                <BoosterRegionSearch2 updateSwitch={this.state.region_switch} updateSelectedRegions={this._updateSelectedRegions}/>
                                            }
                                            {
                                                !this.state.inhouse &&
                                                <RegionSearch updateSwitch={this.state.region_switch} updateSelectedRegions={this._updateSelectedRegions}/>
                                            }
                                            {
                                                <span>
                                            <div className={Styles.subTitleRegular}>
                                                    {this._renderText("item_4")}
                                                <span
                                                    className={Styles.subTitleBold}>{" "}{this.state.industry.name}</span>,
                                                {this._renderText("item_5")}
                                            </div>
                                            <div className={Styles.checkMarksContainer}>
                                                {
                                                    this.state.related_industries.sort(function (a, b) {
                                                        if (a.name < b.name) {
                                                            return -1;
                                                        }
                                                        if (a.name > b.name) {
                                                            return 1;
                                                        }
                                                        return 0;
                                                    }).filter((item, i) => {
                                                        if((i < this.state.count * this.state.page) || this.state.related_open){
                                                            return item
                                                        }
                                                    }).map((prop, i) => {
                                                        return (
                                                            <div key={i} className={Styles.checkMarksContainerItem}>
                                                                {
                                                                    !prop.selected &&
                                                                    <img onClick={() => this._selectRelatedIndustry(prop)}
                                                                         src={require("../../assets/images/checkmark_new.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                {
                                                                    prop.selected &&
                                                                    <img onClick={() => this._selectRelatedIndustry(prop)}
                                                                         src={require("../../assets/images/square_checkmark_active.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                <div onClick={() => this._selectRelatedIndustry(prop)}
                                                                     className={Styles.checkMarksContainerItemText}>
                                                                    {prop.name}
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                                    {
                                                        this.state.related_industries.length > (this.state.count * this.state.page) && !this.state.related_open &&
                                                        <div onClick={() => {
                                                            this.setState({page: this.state.page + 1 });
                                                        }} className={Styles.checkMarksContainerPlus}>
                                                            <img
                                                                className={Styles.checkMarksContainerPlusIcon}
                                                                src={require("../../assets/images/plus_sign_white_small.png")}/>
                                                        </div>
                                                    }
                                        </span>
                                            }
                                            <div className={
                                                cx(Styles.subTitle)
                                            }>
                                                {this._renderText("item_48")}
                                            </div>
                                            {
                                                <div className={Styles.inputContainer}>
                                                    <input onFocus={() => this.setState({dropdown_industry: true})}
                                                           onBlur={() => this.setState({dropdown_industry: false})}
                                                           value={this.state.searchIndustry}
                                                           onChange={(event) => {
                                                               this.setState({searchIndustry: event.target.value}, () => {
                                                                   this._updateIndustries();
                                                               })
                                                           }}
                                                           placeholder={this._renderText("item_49")}
                                                           className={
                                                               cx(Styles.input, Styles.inputLong)
                                                           }
                                                    />
                                                    {
                                                        this.state.dropdown_industry && this.state.industries.length > 0 && this._filterIndustries(this.state.searchIndustry).filter((item) => {
                                                            return item.name.toLowerCase().indexOf(this.state.searchIndustry.toLowerCase()) !== -1
                                                        }).length > 0 &&
                                                        <div className={cx(Styles.inputDropdown, Styles.inputDropdownLong)}>
                                                            {
                                                                this._filterIndustries(this.state.searchIndustry).filter((item) => {
                                                                    return item.name.toLowerCase().indexOf(this.state.searchIndustry.toLowerCase()) !== -1
                                                                }).map((prop, key) => {
                                                                    return (
                                                                        <div key={key}
                                                                             onMouseDown={() => this._selectIndustry(prop)}
                                                                             className={Styles.inputDropdownItem}>
                                                                            {prop.name}
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {
                                                <div className={Styles.regionsContainer}>
                                                    {
                                                        this.state.industries_selected.map((prop, i) => {
                                                            return (
                                                                <div key={i} className={Styles.regionsContainerItem}>
                                                                    <div className={Styles.regionsContainerItemTitle}>
                                                                        {prop.name}
                                                                    </div>
                                                                    <img onClick={() => this._removeIndustry(prop)}
                                                                         src={require("../../assets/images/small_cross_white.png")}
                                                                         className={Styles.regionsContainerItemIcon}
                                                                    />
                                                                </div>
                                                            )

                                                        })
                                                    }
                                                </div>
                                            }

                                        </div>
                                    }
                                    <div className={Styles.divider}/>
                                    <div onClick={() => this._checkout()}
                                         className={
                                             cx(Styles.button,
                                                 {
                                                     [Styles.buttonActive]: this.state.regions_selected.length > 0
                                                     && this.state.targets.filter((item) => {
                                                         return item.selected
                                                     }).length > 0,
                                                 })
                                         }>
                                        {this._renderText("item_14")}
                                        <span className={Styles.mobileButtonPrice}>
                                        {this._renderNumbers(this._renderPartialBudget())}{" "}{this.state.currency.toLowerCase()}
                                    </span>
                                        {
                                            this.state.regions_selected.length < 1 &&
                                            <span className={Styles.buttonError}>{this._renderText("item_33")}</span>
                                        }
                                        {
                                            this.state.targets.filter((item) => {
                                                return item.selected
                                            }).length < 1
                                            && this.state.regions_selected.length > 0 &&
                                            <span className={Styles.buttonError}>{this._renderText("item_42")}</span>
                                        }
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.channels[item].selected && this.state.budget[item].low_traffic_flag && this.state.budget[item].search
                                            }).length > 0 && this.state.regions_selected.length > 0
                                            && this.state.targets.filter((item) => {
                                                return item.selected
                                            }).length > 0 &&
                                            <span className={Styles.buttonError}>{this._renderText("item_32")}</span>
                                        }
                                    </div>
                                    <div onClick={() => {
                                        this._back()
                                    }} className={Styles.backButton}>
                                        {this._renderText("item_23")}
                                    </div>
                                </div>
                                <div className={Styles.right}>

                                    <div className={Styles.contentContainerRightInner}>
                                        <Basket updateBudget={this._updateBudget}
                                                selectDuration={this._selectDuration}
                                                props={this.props}
                                                duration={this.state.duration}
                                                durations={this.state.durations}
                                                nextView={"/signup/budget"}
                                                serviceFeeFixed={this.state.service_fee_fixed}
                                                serviceFeePercentage={this.state.service_fee_percentage}
                                                regions={this.state.regions_selected}
                                                budget={this.state.budget}
                                                channels={this.state.channels}
                                                currency={this.state.currency}
                                                plan={this.state.plan}
                                                vat={this.state.vat}
                                        />
                                        <div onClick={() => this._checkout()} className={
                                            cx(Styles.contentContainerRightButton,
                                                {
                                                    [Styles.buttonActive]: this.state.regions_selected.length > 0
                                                    && this.state.targets.filter((item) => {
                                                        return item.selected
                                                    }).length > 0
                                                })
                                        }>
                                            {this._renderText("item_14")}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
            </div>
        );
    }
}

/*
<div className={Styles.inputContainer}>
                                            {
                                                this.state.regionLoader &&
                                                <div className={Styles.inputContainerLoader}>
                                                    <BeatLoader size={15} color={'#41CBC7'} loading={true}/>
                                                </div>
                                            }
                                            <div style={{position: "relative", flex: 1, display: "flex"}}>
                                                <input onFocus={() => this.setState({dropdown: true}, () => {
                                                    if (this.state.country) {
                                                        this._selectCountry();
                                                    }
                                                })}
                                                       onBlur={() => this.setState({dropdown: false})}
                                                       value={this.state.search}
                                                       onChange={(event) => this.setState({search: event.target.value})}
                                                       placeholder={this._renderText("item_8")}
                                                       className={
                                                           cx(Styles.input,
                                                               {
                                                                   [Styles.inputDisabled]: this.state.country
                                                               })
                                                       }
                                                />
                                                {
                                                    this.state.dropdown && this.state.regions.filter((item) => {
                                                        return item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                    }).filter((item) => {
                                                        return item.id !== this.state.country_region.id
                                                    }).length > 0 &&
                                                    <div className={cx(Styles.inputDropdown, Styles.inputDropdownRegion)}>
                                                        {
                                                            this._filterRegions(this.state.search).filter((item) => {
                                                                return item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                            }).filter((item) => {
                                                                return item.id !== this.state.country_region.id
                                                            }).sort(function (a, b) {
                                                                if (a.name < b.name) {
                                                                    return -1;
                                                                }
                                                                if (a.name > b.name) {
                                                                    return 1;
                                                                }
                                                                return 0;
                                                            }).map((prop, key) => {
                                                                return (
                                                                    <div key={key}
                                                                         onMouseDown={() => this._selectRegion(prop)}
                                                                         className={Styles.inputDropdownItem}>
                                                                        {prop.name}
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                }
                                            </div>
                                            <div className={Styles.regionCheckMarksContainerItem}>
                                                {
                                                    !this.state.country &&
                                                    <img onClick={() => this._selectCountry()}
                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                         className={Styles.regionCheckMarksContainerItemIconOther}/>
                                                }
                                                {
                                                    !this.state.country &&
                                                    <img onClick={() => this._selectCountry()}
                                                         src={require("../../assets/images/checkmark_new.svg")}
                                                         className={Styles.regionCheckMarksContainerItemIconMobile}/>
                                                }
                                                {
                                                    this.state.country &&
                                                    <img onClick={() => this._selectCountry()}
                                                         src={require("../../assets/images/square_checkmark_active.svg")}
                                                         className={Styles.regionCheckMarksContainerItemIcon}/>
                                                }
                                                <div onClick={() => this._selectCountry()}
                                                     className={Styles.regionCheckMarksContainerItemText}>
                                                    {this._renderText("item_7")} {this.state.country_region.name}
                                                </div>
                                            </div>
                                        </div>
 */

/*
<div className={Styles.regionsContainer}>
                                            {
                                                this.state.regions_selected &&
                                                this.state.regions_selected.filter((item) => {
                                                    return item.id !== this.state.country_region.id
                                                }).map((prop, i) => {
                                                    return (
                                                        <div key={i} className={Styles.regionsContainerItem}>
                                                            <div className={Styles.regionsContainerItemTitle}>
                                                                {prop.name}
                                                                {
                                                                    prop.parent &&
                                                                    <span
                                                                        className={Styles.regionsContainerItemSubtitle}>({prop.parent})</span>
                                                                }
                                                            </div>
                                                            <img onClick={() => this._removeRegion(prop)}
                                                                 src={require("../../assets/images/small_cross_white.png")}
                                                                 className={Styles.regionsContainerItemIcon}
                                                            />
                                                        </div>
                                                    )

                                                })
                                            }
                                        </div>
 */

export default SignupFilter;


// WEBPACK FOOTER //
// ./src/pages/signup-filter/component.js